import gql from 'graphql-tag'

export const GET_NGROUP_2_SOURCES = gql`
  query Ngroup2Sources($filter: GetNgroup2SourcesFilter!) {
    ngroup2Sources(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      ngroup2Sources {
        data {
          ngroupId
          vgroupId
          vgroup {
            id
            name
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`
